import MultipleTimesPerWeekRecurrenceCard from './MultipleTimesPerWeekRecurrenceCard'

export default MultipleTimesPerWeekRecurrenceCard



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/UserServices/screens/NextServices/components/MultipleTimesPerWeekRecurrenceCard/index.js